export default __webpack_public_path__ + "images/232d7b518db5ea59875a236cfc0c6ef8.svg";